var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSublimeMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.642101 18.712883h-13.513887l-18.2270807 12.747797c-.8765612.613056-1.0934585 1.818891-.4855625 2.698862l4.1453461 6.00094c.6226631.901246 1.8664191 1.110663 2.7497871.463082l15.463798-11.336447h9.867599c.257905 0 .505256-.10242.687564-.284767l4.31478-4.31478c.379693-.379707.379693-.995433 0-1.37514l-4.31478-4.31478c-.182308-.182308-.429659-.284767-.687564-.284767z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.642101 29.287117h-13.513887l-18.2270807-12.747797c-.8765612-.613056-1.0934585-1.818891-.4855625-2.698862l4.1453461-6.0009401c.6226631-.9012456 1.8664191-1.1106624 2.7497871-.4630818l15.463798 11.3364469h9.867599c.257905 0 .505256.10242.687564.284767l4.31478 4.31478c.379693.379707.379693.995433 0 1.37514l-4.31478 4.31478c-.182308.182308-.429659.284767-.687564.284767z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSublimeMerge);
export default __webpack_public_path__ + "static/media/sublime-merge.dacbf1319c73b98aa81385cf8cef870b.svg";
export { ForwardRef as ReactComponent };